var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import moment from "moment";
import { DayFilterModuleSkeleton } from "./DayFilterModuleSkeleton";
import { useDayFilter } from "./useDayFilter";
import { CardLayout } from "../../../../Shared/components/CardLayout/CardLayout";
export const DayFilter = () => {
    const _a = useDayFilter(), { onlyDaysWithDefaultMeals, mealSelectionStatus, dayFilterDays, dayFilterFormat, selectedDay, handleSelectedDayChange, CreateDayFormattedLabel, sliderSettings } = _a, restProps = __rest(_a, ["onlyDaysWithDefaultMeals", "mealSelectionStatus", "dayFilterDays", "dayFilterFormat", "selectedDay", "handleSelectedDayChange", "CreateDayFormattedLabel", "sliderSettings"]);
    if (onlyDaysWithDefaultMeals && !mealSelectionStatus) {
        return _jsx(DayFilterModuleSkeleton, { filterSettings: sliderSettings });
    }
    if (!dayFilterDays || dayFilterDays.length === 0) {
        return null;
    }
    return (_jsx(CardLayout, Object.assign({ isGridLayout: false, sliderSettings: sliderSettings, cardsToRender: dayFilterDays === null || dayFilterDays === void 0 ? void 0 : dayFilterDays.map((day) => {
            const selected = moment(selectedDay).isSame(day);
            return (_jsx(Box, Object.assign({ id: "button-wrapper", padding: "0 .1875rem" }, { children: _jsx(Button, Object.assign({ fullWidth: true, color: "primary", value: day.toString(), variant: selected ? "contained" : "outlined", onClick: handleSelectedDayChange }, { children: CreateDayFormattedLabel(day, dayFilterFormat) })) }), day.date()));
        }) }, restProps)));
};
